import { render, staticRenderFns } from "./courseBarrageList.vue?vue&type=template&id=6a1a292d"
import script from "./courseBarrageList.vue?vue&type=script&lang=js"
export * from "./courseBarrageList.vue?vue&type=script&lang=js"
import style0 from "./courseBarrageList.vue?vue&type=style&index=0&id=6a1a292d&prod&lang=less&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports